import { makeStyles } from '@material-ui/core/styles';
import { hexToRgba } from '../../../../common/formatters/colorFormatter';

const useStyles = makeStyles((theme) => ({
  button: {
    width: '100%',
    color: theme.palette.text.primary,
    textTransform: 'initial',
    backgroundColor: 'transparent',
    padding: 0,
    marginBottom: '0.5rem',
  },
  findingImageContainer: {
    display: 'flex',
    justifyContent: 'center',
    backgroundColor: hexToRgba(theme.palette.secondary.main, 0.3),
    color: theme.palette.primary.main,
    height: '12rem',
    width: '15rem',
  },
  contact: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-end',
    fontSize: '14px',
    gap: '0.5rem',
  },
  irthExternalId: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: '1rem',
  },
  containerDetection: {
    alignItems: 'center',
    display: 'flex',
    gap: '1rem',
  },
  containerLeft: {
    gap: '2rem',
    display: 'flex',
    flexDirection: 'row',
    height: '5.625rem',
  },
  containerRight: {
    display: 'flex',
    flexDirection: 'column',
    marginRight: '2rem',
  },
  description: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    height: '100%',
  },
  image: {
    height: '5.625rem',
    width: '7.5rem',
  },
  label: {
    fontSize: '18px',
    fontWeight: 600,
  },
  position: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    gap: '1rem',
  },
  root: {
    display: 'flex',
    backgroundColor: theme.palette.container.background,
    borderRadius: '4px',
    boxShadow: '0 2px 4px 0 rgba(0,0,0,0.2)',
    padding: '1.25rem',
    justifyContent: 'space-between',
    width: '100%',
    height: '80%',
    cursor: 'pointer',
  },
  sentIndicator: {
    display: 'flex',
    flexDirection: 'row',
    gap: '1rem',
  },
  textItalic: {
    fontSize: '14px',
    fontStyle: 'italic',
  },
  textLarge: {
    fontSize: '20px',
  },
  textMedium: {
    fontSize: '16px',
  },
  textSmall: {
    fontSize: '14px',
  },
  workZone: {
    display: 'flex',
    flexDirection: 'row',
  },
  workZonePositive: {
    marginLeft: '0.2rem',
    fontSize: '16px',
    textTransform: 'uppercase',
    color: theme.palette.success.main,
  },
  workZoneNegative: {
    marginLeft: '0.2rem',
    fontSize: '16px',
    textTransform: 'uppercase',
    color: theme.palette.error.main,
  },
}));

export default useStyles;
